import React, { useState } from 'react';
import { deleteuseraccount } from '../../actions/users';

function DeleteConfirmationModal({ isOpen, onClose, title, message }) {
    const [isDeleting, setIsDeleting] = useState(false);

    if (!isOpen) return null;

    const handleDeleteAccount = async () => {
        setIsDeleting(true);
        try {
            await deleteuseraccount();
            onClose(); // Close the modal
            localStorage.removeItem("user_token");
            window.location = "/"; // Direct redirection
        } catch (error) {
            console.error("Failed to delete account:", error);
            alert("உங்கள் கணக்கை நீக்கும்போது ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.");
            setIsDeleting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <h2 className="fw-bold">{title || "கணக்கை நீக்கு"}</h2>
                <p>{message || "உங்கள் கணக்கை நீக்க வேண்டும் என்று உறுதியாக இருக்கிறீர்களா? இந்தச் செயலை மீண்டும் மாற்ற முடியாது."}</p>
                <div className="modal-actions">
                    <button
                        className="btn-cancel"
                        onClick={onClose}
                        disabled={isDeleting}
                    >
                        ரத்து செய்
                    </button>
                    <button
                        className="btn-confirm"
                        onClick={handleDeleteAccount}
                        disabled={isDeleting}
                    >
                        {isDeleting ? "நீக்கப்படுகிறது..." : "நீக்கு"}
                    </button>
                </div>
            </div>

            <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal-container {
          background: white;
          padding: 24px;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          max-width: 400px;
          width: 100%;
          text-align: center;
        }
        .modal-actions {
          margin-top: 20px;
          display: flex;
          justify-content: space-around;
        }
        .btn-cancel {
          background: #ccc;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
        }
        .btn-cancel:disabled, .btn-confirm:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .btn-confirm {
          background: #d9534f;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
        </div>
    );
}

export default DeleteConfirmationModal;